module.exports = __webpack_public_path__ + "media/images/sponsors/sponsor-02-d6319e663193bf2f25b3bf87e72cf547.png";